import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-node-checkbox',
    templateUrl: './node-checkbox.component.html',
    styleUrls: ['./node-checkbox.component.scss']
})
export class NodeCheckboxComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    @Input() item: any;

    @Output() changed = new EventEmitter<any>();

    onChange() {
        this.changed.emit(this.item);
    }
}
